import * as React from "react";
import { useLocation } from "react-router-dom";
import { SherpaFooter } from "../../components/layout/SherpaFooter";
import { SherpaHeader } from "../../components/layout/SherpaHeader";
import { SearchHome } from "./SearchHome";
import { GlobalSearchHome } from "./GlobalSearchHome";
import { SearchHomeV2 } from "./SearchHomeV2";
import { GlobalSearchHomeV2 } from "./GlobalSearchHomeV2";
import { AppContext } from "../../setup/context";
import { Preference } from "../../setup/preference";
import useRoutedParamsWithContext from "../../setup/useRoutedParamsWithContext";

const SearchHomeRoute = () => {
    const { instanceId } = useRoutedParamsWithContext();
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const queryText = params.get("queryText") || "";
    const context = React.useContext(AppContext);
    const [isAgenticUI] = React.useState(() => context.hasLab(Preference.Lab.AgenticUI));
    if (isAgenticUI) {
        return <SearchHomeV2 instanceId={instanceId!} queryText={queryText} />;
    }

    return <SearchHome instanceId={instanceId!} queryText={queryText} />;
};

const GlobalSearchHomeRoute = () => {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const queryText = params.get("queryText") || "";
    const context = React.useContext(AppContext);
    const [isAgenticUI] = React.useState(() => context.hasLab(Preference.Lab.AgenticUI));
    if (isAgenticUI) {
        return <GlobalSearchHomeV2 queryText={queryText} />;
    }

    return <GlobalSearchHome queryText={queryText} />;
};

export const searchRoutes = [
    // Global search route
    {
        path: "/search",
        content: <GlobalSearchHomeRoute />,
        header: () => <SherpaHeader headerType="Other" />,
        footer: () => <SherpaFooter variant="PathFinderHome" />
    },
    // Instance home search route
    {
        path: "/search/:instanceId",
        content: <SearchHomeRoute />,
        header: () => {
            const { instanceId } = useRoutedParamsWithContext();
            return <SherpaHeader headerType="Other" instanceId={instanceId!} />;
        },
        footer: () => {
            const { instanceId } = useRoutedParamsWithContext();
            return <SherpaFooter variant="Search" entityId={instanceId!} />;
        }
    }
];
